function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "beb6154d-828c-4af1-9dea-88db8f16532a",
  d: "M50.8 101.5A50.75 50.75 0 1185 13.3L70.1 28a29.8 29.8 0 103.5 42 27.3 27.3 0 005.1-8.7H50.1V40.2h50.3a50.88 50.88 0 01-39.2 60.3 45.3 45.3 0 01-10.4 1zM160 54.6h-17.6v17.6h-12.8V54.6h-17.8V41.8h17.6V24.2h12.8v17.6h17.6l.2 12.8z"
});

var SvgSocialGooglePlus = function SvgSocialGooglePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "97d3c4c2-3543-4d40-b4bc-1ce6ccd976d8",
    viewBox: "0 0 160 101.51",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgSocialGooglePlus;